import React from 'react'
import CompositeSegment from './CompositeSegment'
import SkillBarPrint from './SkillBarPrint'
import SubscoreCirclePrint from './SubscoreCirclePrint'
import forOwn from 'mout/object/forOwn'
import values from 'mout/object/values'
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText'
import computeSummaryNodeData from '../../../helpers/assessment/computeSummaryNodeData'
import TestTakingSummary from './Overview/TestTakingSummary'

export default function OverviewPage ({
  byTest, 
  bySubtest, 
  byNode, 
  nodes, 
  assessmentSubtests, 
  headerText, 
  testTakingData, 
  isGroup,
}) {
  let subtests = {}
	let subjSummaries = []
  forOwn(assessmentSubtests, (val, key) => {
    subtests[val.displayName] = val 
  })

	let subscoreCircles = []
	let compositeSegments = []
	let strokeDashoffset = 25
	sortByPropText(values(subtests), 'displayName').forEach((subtest) => {
		let scaleScore = 0
		if (bySubtest[subtest.setId]) {
			scaleScore = Math.round(bySubtest[subtest.setId].scale * 10) / 10
		}
		const filledIn = Math.round(scaleScore / 36 * 100)
		const notFilledIn = 100 - filledIn 

		subscoreCircles.push(
			<SubscoreCirclePrint
				displayName={subtest.displayName}
				filledIn={filledIn}
				notFilledIn={notFilledIn}
        scaleScore={scaleScore}
        key={`subscoreCircle${subtest.displayName}`}
			/>
		)

		const compositeFilledIn = Math.round(scaleScore / 36 * 100 / 4)
		const compositeNotFilledIn = 100 - compositeFilledIn

		compositeSegments.push(
			<CompositeSegment 
				displayName={subtest.displayName}
				compositeFilledIn={compositeFilledIn}
				compositeNotFilledIn={compositeNotFilledIn}
        strokeDashoffset={strokeDashoffset}
        key={`compositeSegment${subtest.displayName}`}
			/>
		)

		strokeDashoffset -= compositeFilledIn

		const summaryNodeData = computeSummaryNodeData(nodes, byNode[subtest.setId], subtest)

    let skillBars = []
		sortByPropText(summaryNodeData, 'name').forEach((skill, n) => {
			if (skill.possible) {
				const percent = `${Math.round(skill.raw / skill.possible * 100)}%`
				skillBars.push(
					<SkillBarPrint 
						name={skill.name}
						percent={percent}
						key={`${skill.name}${n}`}
					/>
				)
			}
		})

		subjSummaries.push(
			<div className={`${subtest.displayName} Breakdown`} key={`subjSummary${subtest.displayName}`}>
				<hgroup>
					<img 
						className="SubjectIcon" 
						src={`https://bellwork-cg1.firebaseapp.com/img/${subtest.displayName.toLowerCase()}-icon.svg`} 
						alt="" 
					/>
					<h3 className="Title">{subtest.displayName}</h3>
				</hgroup>
				{skillBars}
			</div>
		)



  })
  
  return (
    <div className="new-page vertical-content overview-page">
    <section className="page-header">
      <h2 className="page-title">Score Report</h2>
      <h2 className="school-class-info">{headerText}</h2>
    </section>
    <section className="DonutChartContainer">

      <div className="Composite DonutChart">
        <svg width="100%" height="100%" viewBox="0 0 42 42" className="donut">
          <defs>
            <radialGradient id="english-radial" fx="50%" fy="50%" cx="75%" cy="75%" r="100%">
              <stop offset="0%" stopColor="#a6579d" stopOpacity="1" />
              <stop offset="20%" stopColor="#de4997" stopOpacity="1" />
            </radialGradient>

            <radialGradient id="math-radial" fx="50%" fy="50%" cx="75%" cy="75%" r="100%">
              <stop offset="0%" stopColor="#dc5850" stopOpacity="1" />
              <stop offset="50%" stopColor="#e66c46" stopOpacity="1" />
            </radialGradient>

            <radialGradient id="reading-radial" fx="50%" fy="50%" cx="75%" cy="75%" r="100%">
              <stop offset="0%" stopColor="#95d6ef" stopOpacity="1" />
              <stop offset="50%" stopColor="#53b7c2" stopOpacity="1" />
            </radialGradient>

            <radialGradient id="science-radial" fx="50%" fy="50%" cx="75%" cy="75%" r="100%">
              <stop offset="0%" stopColor="#c5da8c" stopOpacity="1" />
              <stop offset="70%" stopColor="#84b44d" stopOpacity="1" />
            </radialGradient>

          </defs>

          <circle className="DonutRing" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#d2d3d4" strokeWidth="5"></circle>

          {compositeSegments}

          <circle className="DonutShadow" cx="21" cy="21" r="14" fill="transparent" stroke="rgba(0,0,0,0.07)" strokeWidth="1"></circle>
        </svg>
        <div className="ChartText">
          <p className="ChartNumber">
            {byTest.scale ? byTest.scale : '–'}
          </p>
          <p className="ChartLabel">
            Composite
          </p>
        </div>

      </div>
      <div className="Subjects DonutChart">
        {subscoreCircles}
      </div>


    </section>
    <section className="SubjectBreakdowns">
      {subjSummaries}
    </section>
    {isGroup && 
      <TestTakingSummary testTakingData={testTakingData} />
    }
  </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/OverviewPage.js